import React from "react";
import PropTypes from "prop-types";

const Link = ({ children, target, href, title }) => {
    return (
        <a href={href} target={target} className="link" title={title}>
            {children}
        </a>
    );
};

Link.propTypes = {
    children: PropTypes.node,
    href: PropTypes.node,
    target: PropTypes.string,
    title: PropTypes.string,
};

Link.defaultProps = {
    children: "",
    href: "",
    target: "",
    title: undefined,
};

export default Link;
